export const onlyNumbers = /\D/g;
export const onlyLetters = /[^A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]/gi;
